import MainSkills from "../../components/Forms/MainSkills";
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import MyPlanForm from "../../components/Forms/MyPlanForm";


function MyPlanManager() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <MyPlanForm/>
            </BasicCard>
        </>
    )
}
export default MyPlanManager;